export class Parser {
    constructor(input) {
        this.input = input;
        this.parse = this.parse.bind(this);
    }
    parse() {
        return "";
    }
    setInput(input) {
        this.input = input;
    }
}


// WEBPACK FOOTER //
// ./src/parser/AbstractParser.js